"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.TicketShopThemeVariables = exports.TicketShopThemeLabel = exports.TicketShopTheme = exports.DEFAULT_THEME_CONTEXT = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _themeMapper = require("@gravity/theme-mapper");
function cov_1irk7m1fo3() {
  var path = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/constants.js";
  var hash = "1770b9891112ac6e31ed82a9cb21dc3c525c0a60";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 24
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 29
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "2": {
        start: {
          line: 14,
          column: 33
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "3": {
        start: {
          line: 19,
          column: 30
        },
        end: {
          line: 22,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1770b9891112ac6e31ed82a9cb21dc3c525c0a60"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1irk7m1fo3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1irk7m1fo3();
/* eslint-disable import/prefer-default-export */
var TicketShopTheme = exports.TicketShopTheme = (cov_1irk7m1fo3().s[0]++, {
  EQUILIBRIUM: 'EQUILIBRIUM',
  EVOLUTION: 'EVOLUTION'
});
var TicketShopThemeLabel = exports.TicketShopThemeLabel = (cov_1irk7m1fo3().s[1]++, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, TicketShopTheme.EQUILIBRIUM, 'Equilibrium'), TicketShopTheme.EVOLUTION, 'Evolution'));
var TicketShopThemeVariables = exports.TicketShopThemeVariables = (cov_1irk7m1fo3().s[2]++, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, TicketShopTheme.EQUILIBRIUM, _themeMapper.defaultTheme), TicketShopTheme.EVOLUTION, _themeMapper.evolutionTheme));
var DEFAULT_THEME_CONTEXT = exports.DEFAULT_THEME_CONTEXT = (cov_1irk7m1fo3().s[3]++, {
  theme: TicketShopTheme.EQUILIBRIUM,
  variables: TicketShopThemeVariables[TicketShopTheme.EQUILIBRIUM]
});